<template>
  <div>
    <Head :title="beneficiaryFamily.head_name" />
    <h1 class="mb-8 text-3xl font-bold">
      Transaksi
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/assessments">
        Assessment
      </Link>
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" :href="`/assessments/${assessmentMaster.id}/edit`">
        {{ assessmentMaster.code }}
      </Link>
      <span class="text-indigo-400 font-medium"> / </span>
      {{ beneficiaryFamily.head_name }}
    </h1>
    <div class="flex justify-between my-5">
      <button class="btn-indigo" @click="createMode = true">
        <span>Create</span> <span class="hidden md:inline">&nbsp;Anggota</span>
      </button>
    </div>
    <div class="mt-6 bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <member-row
          v-for="(member, idx) in members"
          :key="member.id"
          :row-index="++idx"
          :editable-mode="member.editable"
          :assessment-member="member"
          :errors="$page.props.errors"
          :disabilities="disabilities"
          @destroy:detail="destroyDetail"
          @edit:detail="editDetail"
          @cancel="cancel('edit')"
          @save="updateDetail" />
        <member-row
          v-if="createMode"
          :key="0"
          :editable-mode="createMode"
          :assessment-member="editedItem"
          :errors="$page.props.errors"
          :disabilities="disabilities"
          @cancel="cancel('create')"
          @save="createDetail" />
        <tr v-if="members?.length === 0">
          <td class="px-6 py-4 border-t" colspan="5">
            No members found.
          </td>
        </tr>
      </table>
    </div>
    <div v-if="members?.length >= 1" class="flex justify-between my-5">
      <button class="btn-indigo" @click="createMode = true">
        <span>Create</span> <span class="hidden md:inline">&nbsp;Anggota</span>
      </button>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import MemberRow from '@/Pages/Assessments/MemberRow'
import find from 'lodash/find'

export default {
    components: {
        Head,
        Link,
        MemberRow,
    },
    layout: Layout,
    props: {
        assessmentMaster: Object,
        beneficiaryFamily: Object,
        members: Array,
        disabilities: Array,
    },
    remember: 'form',
    data () {
        return {
            createMode: false,
            editedItem: {
                id: null,
                beneficiary_family_id: null,
                name: '',
                nik: '',
                gender: null,
                age: null,
                dob: null,
                relationship: '',
                is_pregnant: false,
                disability_types: [],
                medical_conditions: [],
                special_needs: [],
                desc: '',
                deleted_at: null,
                editable: false,
            },
        }
    },
    methods: {
        editDetail (detail) {
            const edited = find(this.members, ['id', detail.id])
            edited.editable = true
        },
        destroyDetail (detailId) {
            this.$inertia.delete(`/assessments/${this.assessmentMaster.id}/families/${this.beneficiaryFamily.id}/members/${detailId}`)
        },
        resetEditedItem () {
            this.editedItem = {
                id: null,
                beneficiary_family_id: this.beneficiaryFamily.id,
                name: '',
                nik: '',
                gender: null,
                age: null,
                dob: null,
                relationship: '',
                is_pregnant: false,
                disability_types: [],
                medical_conditions: [],
                special_needs: [],
                desc: '',
                editable: false,
            }
            this.createMode = false
        },
        cancel (action) {
            if (action === 'create') this.resetEditedItem()
            if (action === 'edit') this.$inertia.reload({ only: ['members'] })
        },
        createDetail (value) {
            const formDetail = this.$inertia.form({
                name: value.name,
                nik: value.nik,
                gender: value.gender,
                age: value.age,
                dob: value.dob,
                relationship: value.relationship,
                is_pregnant: value.is_pregnant ? 1 : 0,
                disability_types: value.disability_types || [],
                medical_conditions: value.medical_conditions || [],
                special_needs: value.special_needs || [],
                desc: value.desc,
            })
            formDetail.post(`/assessments/${this.assessmentMaster.id}/families/${this.beneficiaryFamily.id}/members`, {
                preserveScroll: true,
                onSuccess: () => {
                    this.resetEditedItem()
                },
                onError: () => {
                    this.editedItem = value
                },
            })
        },
        updateDetail (value) {
            const formDetail = this.$inertia.form({
                name: value.name,
                nik: value.nik,
                gender: value.gender,
                age: value.age,
                dob: value.dob,
                relationship: value.relationship,
                is_pregnant: value.is_pregnant ? 1 : 0,
                disability_types: value.disability_types || [],
                medical_conditions: value.medical_conditions || [],
                special_needs: value.special_needs || [],
                desc: value.desc,
            })
            formDetail.put(`/assessments/${this.assessmentMaster.id}/families/${this.beneficiaryFamily.id}/members/${value.id}`, {
                preserveScroll: true,
                onError: () => {
                    this.editedItem = value
                },
            })
        },
    },
}
</script>
